import { memo } from 'react';
import { TableCells, SortParamsArg } from 'models';
import { Table as MuiTable, TableBody } from '@material-ui/core';
import TableHeader from './table-header';
import TableRow from './table-row';
import { NoData, Loader } from 'components';
import { useStyles } from './style';
import { Centered } from 'components/styled-components';

interface Props<T extends { Id: string }> {
  tableCells: TableCells<T>[];
  order: 'asc' | 'desc';
  orderBy: string;
  list: T[];
  loading?: boolean;
  renderRow?: (
    item: T,
    tableCells: TableCells<T>[],
    handleRowClick?: (item: T) => void
  ) => JSX.Element;
  handleChangeSortParams: (params: SortParamsArg) => void;
  handleRowClick?: (item: T) => void;
  fixed?: boolean;
  noData?: string;
}

function Table<T extends { Id: string }>({
  tableCells,
  list,
  order,
  orderBy,
  loading,
  handleRowClick,
  handleChangeSortParams,
  renderRow,
  fixed = true,
  noData,
}: React.PropsWithChildren<Props<T>>) {
  const classes = useStyles();
  const renderList = () => {
    return list.map(
      renderRow
        ? (item) => renderRow(item, tableCells, handleRowClick)
        : (item) => {
            return (
              <TableRow
                key={item.Id}
                item={item}
                tableCells={tableCells}
                handleRowClick={handleRowClick}
              />
            );
          }
    );
  };

  return (
    <>
      <MuiTable classes={fixed ? { root: classes.table } : undefined}>
        <TableHeader
          tableCells={tableCells}
          order={order}
          orderBy={orderBy}
          handleChangeSortParams={handleChangeSortParams}
        />
        <TableBody>{!list.length || loading ? null : renderList()}</TableBody>
      </MuiTable>
      {loading ? (
        <Centered className={classes.mt10}>
          <Loader themeColor="darkBlue" className={classes.loader} size={30} />
        </Centered>
      ) : !list.length ? (
        <NoData text={noData} />
      ) : null}
    </>
  );
}

export default memo(Table);
